export const SEARCH_MATCH_HIGHLIGHT_ATTRIBUTE = 'data-docs-search-match'

export const SEARCH_MATCH_HIGHLIGHT_RETRY_MS = [0, 100, 300, 800] as const
